module.exports = __webpack_public_path__ + "media/stylesheets/flag-icon-css/flags/1x1/ai-546a12e334b3f4d8967c7cd65178f7f0.svg";